import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { adminGetGiftBlocks, adminRemoveGiftBlock, isOk, messageOf } from "../../../services/gift";
import "./admin-gifts.css";

// Admin: purchasers barred from creating gifts (added from a gift's detail page).
export default function AdminGiftBlocks() {
  const [blocks, setBlocks] = useState([]);

  const load = () => {
    adminGetGiftBlocks().then((res) => {
      if (isOk(res)) {
        setBlocks(res.data.data);
      } else {
        toast.error(messageOf(res, "Blocks could not be loaded."), { position: "top-center" });
      }
    });
  };

  useEffect(load, []);

  const remove = async (block) => {
    if (!window.confirm(`Remove the block on ${block.email || block.user_id}? They will be able to create gifts again.`)) {
      return;
    }
    const res = await adminRemoveGiftBlock(block.id);
    if (isOk(res)) {
      toast.success("Block removed.", { position: "top-center" });
      load();
    } else {
      toast.error(messageOf(res, "Block could not be removed."), { position: "top-center" });
    }
  };

  return (
    <div className="admin-gifts">
      <p>
        <Link to="/gifts">&larr; All gifts</Link>
      </p>
      <h2>Blocked gift purchasers</h2>
      <div className="table-box-medium admin-appoi admin-upcoming-app mt-3">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th>User id</th>
              <th>Email</th>
              <th>IP</th>
              <th>Reason</th>
              <th>Blocked by</th>
              <th>When</th>
              <th />
            </tr>
            {blocks.map((block) => (
              <tr key={block.id} className="innr-dark">
                <td>{block.user_id || "—"}</td>
                <td>{block.email || "—"}</td>
                <td>{block.ip || "—"}</td>
                <td>{block.reason || ""}</td>
                <td>{block.created_by || "—"}</td>
                <td>{block.created_at ? new Date(block.created_at).toLocaleString() : ""}</td>
                <td>
                  <button type="button" className="proceed-btn" onClick={() => remove(block)}>
                    Unblock
                  </button>
                </td>
              </tr>
            ))}
            {blocks.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center">No blocked purchasers.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
